import { useEffect } from 'react';

const JIRA_SCRIPT_ID = 'jsd-widget-script';

const JsdWidgetProvider = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = JIRA_SCRIPT_ID;
    script.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
    script.async = true;

    script.setAttribute('data-jsd-embedded', '');
    script.setAttribute('data-key', 'b5321598-1315-420b-87a6-94f68c179611');
    script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');

    document.body.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(JIRA_SCRIPT_ID);
      if (scriptToRemove) {
        document.body.removeChild(scriptToRemove);
      }

      const widgetContainer = document.querySelector('.jsd-widget-container');
      if (widgetContainer) {
        widgetContainer.parentElement.removeChild(widgetContainer);
      }
    };
  }, []);

  return null;
};

export default JsdWidgetProvider;
